import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const ProductCostRecord = Record({
  min: {
    value: 0,
    description: '',
  },
  max: {
    value: 0,
    description: '',
  },
  average: {
    value: 0,
    description: '',
  },
});

export default class ProductCost extends ProductCostRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new ProductCost(hydrated);
  }
}
